<template>
  <div class="otb-range-date-picker">
    <calendar-picker
      :formLabel="pickupFormLabel"
      :labelPlaceholder="pickupPlaceholderLabel"
      :rangePicker="startMode"
      :selectedDates="selectedRangeDate"
      :selectedDay="selectedDay"
      :pickerVisibility="showPickUpPicker"
      :isMobile="isMobile"
      :dealerCalendar="dealerCalendar"
      :calendarStartDate="calendarStartDate"
      :selectedTime="getSelectedRangeStartTime"
      :availableTime="getTimeSlots.start"
      :hourPlaceholder="pickupHourLabel"
      :activeTextCarouselSlide="activeTextCarouselSlideRange.start"
      @onPickerToggle="onPickerToggle"
      @changeDate="changeDate($event, startMode.workingMode)"
      @maskCalendar="maskCalendarSection"
      @unmaskCalendar="unmaskCalendarSection"
      @changeTime="changeTime($event, startMode.workingMode)"
      @changeSheet="
        changeActiveTextCarouselSlide($event, startMode.workingMode)
      "
    ></calendar-picker>

    <calendar-picker
      :formLabel="returnFormLabel"
      :labelPlaceholder="returnPlaceholderLabel"
      :rangePicker="endMode"
      :selectedDates="selectedRangeDate"
      :selectedDay="selectedDay"
      :pickerVisibility="showReturnPicker"
      :isMobile="isMobile"
      :dealerCalendar="endCalendar"
      :calendarStartDate="calendarStartDate"
      :selectedTime="getSelectedRangeEndTime"
      :availableTime="getTimeSlots.end"
      :hourPlaceholder="returnHourLabel"
      :activeTextCarouselSlide="activeTextCarouselSlideRange.end"
      @onPickerToggle="onPickerToggle"
      @changeDate="changeDate($event, endMode.workingMode)"
      @maskCalendar="maskCalendarSection"
      @unmaskCalendar="unmaskCalendarSection"
      @changeTime="changeTime($event, endMode.workingMode)"
      @changeSheet="changeActiveTextCarouselSlide($event, endMode.workingMode)"
    ></calendar-picker>
  </div>
</template>
<script lang="ts">
import { defineComponent, watch } from 'vue';

import { CarouselSlideRange } from '../../models/entities/text-carousel.model';
import {
  DateWorkingMode,
  DatesAvailabilityType,
  RangeSchedules,
} from '../../models/entities/calendar.model';
import {
  TimeOption,
  TimeWorkingMode,
} from '../../models/entities/timeslot.model';
import { DmoBooking, RentalDayAvailability } from '../../graphql/schema';

import useRangeDatePicker from '../../composables/range-date-picker.composable';

export default defineComponent({
  name: 'otb-range-date-picker',
  components: {
    CalendarPicker: () => import('../calendar-picker/index.vue'),
  },
  props: {
    activeDealerCalendar: Array as () => RentalDayAvailability[],
    activeTextCarouselSlideRange: Object as () => CarouselSlideRange,
    calendarStartDate: {
      type: Date,
      default() {
        return new Date();
      },
    },
    dealerCalendar: Object as () => DatesAvailabilityType,
    firstUnavailableDate: {
      type: Date,
      default() {
        return new Date(new Date().setMonth(new Date().getMonth() + 3));
      },
    },
    isMobile: Boolean,
    pickupFormLabel: String,
    pickupHourLabel: String,
    pickupPlaceholderLabel: String,
    returnFormLabel: String,
    returnHourLabel: String,
    returnPlaceholderLabel: String,
    rentalSlotTimes: {
      type: Object as () => RangeSchedules,
      default() {
        return {
          start: {
            closingTime: '18:00',
            openingTime: '08:30',
          },
          end: {
            closingTime: '18:00',
            openingTime: '08:30',
          },
        };
      },
    },
    rentalTimeConfig: {
      type: Object as () => DmoBooking,
      default() {
        return { timeSlotInterval: 30, minimumDuration: 60 };
      },
    },
    selectedDay: {
      type: Date,
      default() {
        return new Date();
      },
    },
    selectedRangeDate: {
      type: Object as () => DateWorkingMode,
      default() {
        return {
          start: new Date(new Date().setDate(new Date().getDate() + 3)),
          end: new Date(new Date().setDate(new Date().getDate() + 4)),
        };
      },
    },
    selectedRangeTime: {
      type: Object as () => TimeWorkingMode,
      default() {
        return {
          start: {
            disabled: false,
            value: '08:30',
          },
          end: {
            value: '17:30',
            disabled: false,
          },
          zoneOffSet: '+02:00',
        };
      },
    },
  },
  setup(props, { emit }) {
    const RangeDatePicker = useRangeDatePicker(props, { emit });

    watch(
      RangeDatePicker.getTimeSlots,
      (value: { start: TimeOption[]; end: TimeOption[] }): void => {
        const [endSlot] = value.end.slice(-1);
        if (endSlot.value < props.selectedRangeTime.end.value) {
          emit('selectedRangeTimeMutation', {
            ...props.selectedRangeTime,
            end: endSlot,
          });
        }
      }
    );

    return {
      ...RangeDatePicker,
    };
  },
});
</script>
<style src="./range-date-picker.scss" lang="scss"></style>
